/* eslint-disable no-extra-boolean-cast */
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { z } from 'zod';
import { zodResolver } from '@hookform/resolvers/zod';
import ValidationCpforCnpj from '@/validations/cpfCnpj/validationCpfCnpj';
import CustomInputMask from '@/utils/customInputMask';
import { PlusIcon, User, UsersIcon, ContactRound } from 'lucide-react';
import { Button } from '@/components/shadcn/ui/button';
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/shadcn/ui/dialog';
import { Input, InputMasks } from '@/components/shadcn/ui/input';
import { Form, FormControl, FormField, FormLabel, FormItem, FormMessage } from '@/components/shadcn/ui/form';
import { useClientContext } from '@/context/ClientContext';
import { useClients } from '@/hook/useClients';
import { ClientContact } from '@/entities/clientContact';

type ContactFormProps = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onClientSubmit: (dataContact: any, clientId:number | undefined) => void;
  clientId: number;
  // setOpen: (open: boolean) => void;
  // isOpen: boolean;
};

{/* validação */}
const schema = z.object({
  id: z.number(),
  nomeContato: z.string(),
  celular: z.optional(z.string()), 
  fixo: z.optional(z.string()), 
  email: z.optional(z.string().email('Digite um email válido')), 
  funcao: z.optional(z.string()),
  clientId: z.optional(z.number()),
});

const ContactFormDialog: React.FC<ContactFormProps> = ({ onClientSubmit, clientId}) => {

  const { openContact, setOpenContact, isEditContact, setEditContact, data2Edit, setData2Edit, indexEdit} = useClientContext();
  const { getContactList, deleteContact, contatos, setContatos } = useClients();
  const titleLabel = isEditContact ? 'Editar Contato' : 'Novo Contato';

  const form = useForm<z.infer<typeof schema>>({
    resolver: zodResolver(schema),
  });

  useEffect(() => {
    if (data2Edit) {
      form.setValue('id', data2Edit.id || NaN);
      form.setValue('nomeContato', data2Edit.name || '');
      form.setValue('celular', data2Edit.cellPhone || '');
      form.setValue('fixo', data2Edit.phone || '');
      form.setValue('email', data2Edit.email || '');
      form.setValue('funcao', data2Edit.function || '');
    } else{
      form.setValue('id', NaN);
      form.setValue('nomeContato', '');
      form.setValue('celular', '');
      form.setValue('fixo', '');
      form.setValue('email',  '');
      form.setValue('funcao', '');
    }
  }, [data2Edit, form]);

  const handleSubmit =  (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const data = form.getValues();
    const data2 = {
      name: data.nomeContato,
      email: data.email,
      phone: data.fixo,
      cellPhone: data.celular,
      function: data.funcao,
    };
    const data3 = {
      id:data.id,
      name: data.nomeContato,
      email: data.email,
      phone: data.fixo,
      cellPhone: data.celular,
      function: data.funcao,
    };
    if(indexEdit !== undefined){
      onClientSubmit(data3, undefined);
    }else{
      onClientSubmit(data2, clientId);
    }
    setOpenContact(false);
    setEditContact(false);
  };
  
  return (
    <Dialog open={openContact} onOpenChange={()=>{
      setOpenContact(!openContact);
    }}>
      <DialogTrigger>
        
        {/* <ContactRound aria-hidden={true}  size={26}  className='bg-indigo-50 hover:bg-indigo-200 rounded-md p-1 mt-1'
          onClick={()=>{
            // setEditContact(false);
            // setData2Edit(undefined);
          }}/> */}
      </DialogTrigger> 
      <DialogContent className='max-w-[54vw]'> 
        <DialogHeader>
          <DialogTitle>
            <div className='flex items-center gap-2 font-medium text-md'>
              <UsersIcon size={22} />
              {titleLabel}
            </div>
          </DialogTitle>
        </DialogHeader>

        {/* Começo do Formulário */}
        <Form {...form}>
          <form onSubmit={handleSubmit} className="space-y-8">
            <div className='grid gap-4 pt-2'>

              {/* Nome do Contato */}
              <FormField
                control={form.control}
                name='nomeContato'
                render={({ field }) => (
                  <FormItem>
                    <FormLabel>Nome do Contato</FormLabel>
                    <FormControl>
                      <Input 
                        {...field}
                        placeholder="Digite o Nome do contato"
                      />
                    </FormControl>
                    <FormMessage />
                  </FormItem>
                )}
              />

              {/* Celular */}
              <FormField
                control={form.control}
                name='celular'
                render={({ field }) => (
                  <FormItem>
                    <FormLabel>Celular</FormLabel>
                    <FormControl>
                      <InputMasks
                        {...field}
                        mask="(99) 99999-9999"
                        placeholder="Digite o número de telefone do contato" />
                    </FormControl>
                    <FormMessage />
                  </FormItem>
                )}
              />
              {/* Fixo */}
              <FormField
                control={form.control}
                name='fixo'
                render={({ field }) => (
                  <FormItem>
                    <FormLabel>Fixo</FormLabel>
                    <FormControl>
                      <InputMasks
                        {...field}
                        mask="(99) 99999-9999"
                        placeholder="Digite o número de telefone do contato" />
                    </FormControl>
                    <FormMessage />
                  </FormItem>
                )}
              />

              {/* Email do Contato */}
              <FormField
                control={form.control}
                name='email'
                render={({ field }) => (
                  <FormItem>
                    <FormLabel>Email</FormLabel>
                    <FormControl>
                      <Input placeholder="Digite o Email do Contato" {...field} />
                    </FormControl>
                    <FormMessage />
                  </FormItem>
                )}
              />
              {/** funcao */}
              <FormField
                control={form.control}
                name='funcao'
                render={({ field }) => (
                  <FormItem>
                    <FormLabel>Função</FormLabel>
                    <FormControl>
                      <Input placeholder="Digite a função do contato" {...field} />
                    </FormControl>
                    <FormMessage />
                  </FormItem>
                )}
              />
            </div>
            <DialogFooter>
              <Button type="submit" onClick={()=>{setEditContact(false);}} className='bg-indigo-700'>Salvar Contato</Button>
            </DialogFooter>
          </form>
        </Form> 
      </DialogContent> 
    </Dialog>
  
  );
};

export default ContactFormDialog;
